import { graphql } from 'src/graphql';

import type { ResultOf } from 'src/graphql';

export const SessionTeamFields = graphql(`
  fragment SessionTeamFields on Booking @_unmask {
    _id
    config {
      contact {
        _facilitator_user_id
      }
      session {
        moderators {
          _user_id
          allow_booking_over_events
          calendars {
            integration
            status
          }
        }
        observers {
          _user_id
          email
        }
      }
    }
  }
`);

export const SessionTeam = graphql(
  `
    query SessionTeam($id: ID) {
      bookingByID(id: $id) {
        ...SessionTeamFields
      }
    }
  `,
  [SessionTeamFields],
);

export const UpdateSessionTeam = graphql(
  `
    mutation UpdateSessionTeam($_id: ID!, $input: UpdateBookingConfigInput!) {
      updateBookingConfig(_id: $_id, input: $input) {
        ...SessionTeamFields
      }
    }
  `,
  [SessionTeamFields],
);

type Session = NonNullable<NonNullable<NonNullable<ResultOf<typeof SessionTeam>['bookingByID']>['config']>['session']>;
export type Moderator = NonNullable<Session['moderators']>[number];
export type Observer = NonNullable<Session['observers']>[number];
